import { useTheme } from '@material-ui/core/styles';

/**
 * Picks the value meant for the active theme's mode: `onDark` when the
 * Material UI palette type is `dark`, `onLight` otherwise.
 *
 * Read from the Material UI theme because every caller renders inside
 * UnifiedThemeProvider: the sidebar like the rest of the app, and the sign-in
 * page too — plugin-app's `App` extension wraps the whole root, sign-in page
 * included, in AppThemeProvider.
 */
export function useThemeVariant<T>(onLight: T, onDark: T): T {
  const theme = useTheme();
  return theme.palette.type === 'dark' ? onDark : onLight;
}
